import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=6214dc07"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/srv/app/components/picture/Picture.vue').default,ButtonIcon: require('/srv/app/components/button/ButtonIcon.vue').default,Button: require('/srv/app/components/button/Button.vue').default,Icon: require('/srv/app/components/icon/Icon.vue').default,Button: require('/srv/app/components/button/Button.vue').default})
